// extracted by mini-css-extract-plugin
module.exports = {"wf2imp2":"wf2imp2"};